import { ApplicationConfig, importProvidersFrom } from '@angular/core'
import { provideRouter } from '@angular/router'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'

import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics'
import { provideAuth, getAuth } from '@angular/fire/auth'
import { provideStorage, getStorage } from '@angular/fire/storage'
import { provideFirestore, getFirestore } from '@angular/fire/firestore'

import { routes } from './app-routing.module'
import { environment } from 'src/environments/environment'
import { AuthInterceptor } from './core/interceptors/auth.interceptor'
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations'
import { ThemeOptions } from './theme-options'
import { AppState } from './app-state'
import { WebSocketService } from './web-socket-handlers/web-socket.service'
import { ThemeService } from './core/services/theme.service'
import { AuthService } from './core/services/auth.service'
import { CustomClaimService } from './core/services/custom-claim.service'
import { provideServiceWorker } from '@angular/service-worker'
import { provideNgxMask } from 'ngx-mask'

// import { provideToastr } from 'ngx-toastr'

// const config: SocketIoConfig = { url: 'http://localhost:8080', options: {} }; // Replace with your server URL


export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        importProvidersFrom([
            HttpClientModule,
            BrowserAnimationsModule
        ]),
        // Core Services
        AppState,
        WebSocketService,
        ThemeService,
        AuthService,
        CustomClaimService,
        // HTTP Interceptors
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        // Legacy Theme Options (kept for compatibility)
        ThemeOptions,
        // Input masking (phone). Registered with no option overrides so each
        // input controls dropSpecialCharacters/validation itself.
        provideNgxMask(),
        // Firebase
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        // Service Worker (enabled in production/staging only)
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.serviceWorkerEnabled,
            registrationStrategy: 'registerWhenStable:30000'
        })
    ]
}
